import Container from '@/components/container/Container';
import Spacing from '@/components/container/Spacing';
import { CustomText, TextLabelLarge } from '@/components/text/Texts';
import { classNames } from 'primereact/utils';
import { MdInfo } from 'react-icons/md';
import ViewModeToggleButton from './ViewModeToggleButton';

type Props = {
	label: string;
	value: string;
	hasMode?: boolean;
	viewMode?: 'week' | 'day';
	setViewMode?: React.Dispatch<React.SetStateAction<'week' | 'day'>>;
};

const ChartLabel = ({
	label,
	value,
	hasMode,
	viewMode,
	setViewMode,
}: Props) => {
	const showButton = hasMode && viewMode && setViewMode;
	return (
		<Container>
			<div
				className={classNames({
					'flex flex-col gap-5 items-center md:grid md:grid-cols-2':
						hasMode,
					'md:grid md:grid-cols-1': !hasMode,
				})}
			>
				<div className="flex">
					<TextLabelLarge
						className="text-neutral50 text-[18px]"
						text={label}
					/>
					<div>
						<MdInfo
							size={24}
							className="ml-2 text-neutral50"
							data-pr-tooltip="Some products may not be available in your location but available in other locations where your employee might travel to."
							data-pr-position="bottom"
							id="info"
						/>
					</div>
				</div>
				{showButton && (
					<div className="flex justify-end items-center">
						<ViewModeToggleButton
							value={viewMode}
							setValue={setViewMode}
							btnLabel1={'Days'}
							btnLabel2={'Week'}
							btnId1={'day'}
							btnId2={'week'}
						/>
					</div>
				)}
			</div>
			<Spacing height="h-2" />
			<CustomText
				text={value}
				className="text-primary text-[44px] font-medium leading-[52px]"
			/>
			<Spacing height="h-2" />
		</Container>
	);
};

export default ChartLabel;
